
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flight-schedule/[[...param]]",
      function () {
        return require("private-next-pages/flight-schedule/[[...param]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flight-schedule/[[...param]]"])
      });
    }
  